import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  name: 'Identifica el Ciclo de Sabotaje',
  desc: 'Diagnosticas tus frases limitantes de la infancia y tu relación emocional con el dinero'
}, {
  num: '2',
  name: 'Rompe y Reemplaza',
  desc: 'Aplicas el método de 5 pasos para instalar nuevas creencias de abundancia en tu subconsciente'
}, {
  num: '3',
  name: 'Mentalidad Inquebrantable',
  desc: 'Conviertes el fracaso temporal en retroalimentación y programas tus pensamientos dominantes'
}, {
  num: '4',
  name: 'Visualización con Propósito',
  desc: 'Vives en mentalidad de abundancia antes de ver resultados, alineando fe y acción'
}, {
  num: '5',
  name: 'Organización Inteligente',
  desc: 'Creas una estructura financiera clara con el Método 70/30 para que tu abundancia tenga un recipiente práctico'
}, {
  num: '6',
  name: 'Acción Consistente',
  desc: 'Transformas sueños en números reales con micro-acciones semanales que generan transformación en un año'
}, {
  num: '7',
  name: 'Hoja de Ruta Maestra',
  desc: 'Estructuras tu Plan de Acción a 30, 90 y 365 días con metas medibles y la Fórmula 70/30'
}];
export function StepsSection() {
  return <section className="py-10 md:py-14 px-4 md:px-8 bg-navy-dark" data-id="element-293">
      <div className="max-w-5xl mx-auto" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-295">
          <h3 className="text-3xl md:text-5xl font-headline font-extrabold text-white" data-id="element-296">
            Los 7 Pasos Del Sistema
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-297">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-midnight border border-gold-separator/20 rounded-xl p-6 flex flex-col md:flex-row gap-6 items-start md:items-center hover:border-gold/50 transition-all group shadow-soft hover:shadow-gold" data-id="element-298">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-navy-dark border-2 border-gold flex items-center justify-center text-xl font-headline font-bold text-gold group-hover:bg-gold group-hover:text-navy-dark transition-colors" data-id="element-299">
                {step.num}
              </div>
              <div className="md:w-1/3" data-id="element-300">
                <h4 className="text-xl font-headline font-bold text-white group-hover:text-gold-light transition-colors" data-id="element-301">
                  {step.name}
                </h4>
              </div>
              <div className="md:w-2/3" data-id="element-302">
                <p className="text-body font-body" data-id="element-303">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}